import { ListConferenceFiles } from 'domain/usecases/conferenceFiles/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteListConferenceFiles implements ListConferenceFiles {
  private readonly url: string;

  private readonly httpClient: HttpClient<ListConferenceFiles.Model>;

  constructor(url: string, httClient: HttpClient<ListConferenceFiles.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  list = async (
    params: ListConferenceFiles.Params,
  ): Promise<ListConferenceFiles.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.short}/files/list`,
      method: 'post',
      headers: params?.token
        ? {
            Authorization: `APIKEY ${params?.token}`,
          }
        : undefined,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      default:
        throw new UnexpectedError();
    }
  };
}
